// extracted by mini-css-extract-plugin
export default {"filter":"VoiceCardsContainer_filter__Sn8f7","cont":"VoiceCardsContainer_cont__ypn6U","cards":"VoiceCardsContainer_cards__cvhRS","search":"VoiceCardsContainer_search__K5dJd"};